import * as cucumberTooltip from './cucumbers/tooltip.js';
import * as cucumberSizes from './cucumbers/sizes.js';

/** One folder per crop: pulse/<crop>/{tooltip.js,sizes.js}. Register it here. */
const BY_COMMODITY = {
  cucumbers: { tooltip: cucumberTooltip, sizes: cucumberSizes },
};

const EMPTY_TOOLTIP = {};

export function pulseTooltipRules(commodity) {
  const key = String(commodity || '').trim().toLowerCase();
  return BY_COMMODITY[key]?.tooltip || EMPTY_TOOLTIP;
}

export function commoditySizeRules(commodity) {
  const key = String(commodity || '').trim().toLowerCase();
  return BY_COMMODITY[key]?.sizes || null;
}

export { dimLabel, isPlaceholderDim } from './dim.js';
export { sizeTokens as cucumberSizeTokens } from './cucumbers/tooltip.js';
